import React, { useMemo, useState } from 'react'

export const useAvailabilityRequiredFields = (selectedDate: Date | undefined, locationHasValue: boolean) => {
  const [locationTouched, setLocationTouched] = useState(false)

  const handleLocationBlur = () => {
    setLocationTouched(true)
  }

  const locationError = locationTouched && !locationHasValue ? 'Wedding location is required' : undefined

  const requiredHint = useMemo(() => {
    if (!selectedDate && !locationHasValue) return 'Select your wedding date and add your wedding location to continue.'
    if (!selectedDate) return 'Select your wedding date to continue.'
    if (!locationHasValue) return 'Add your wedding location to continue.'
    return undefined
  }, [selectedDate, locationHasValue])

  return { locationError, requiredHint, handleLocationBlur }
}

export const RequiredMarker = () => (
  <span className="required-marker" aria-hidden="true">
    *
  </span>
)

export const RequiredHint = ({ hint }: { hint?: string }) =>
  hint ? (
    <p className="required-hint" role="status">
      {hint}
    </p>
  ) : null
